module.exports = __webpack_public_path__ + "static/media/map-marker-doctor-active.b6c3052f.svg";